import shopeeApi from '../api/shopeeApi';
import lazadaApi from '../api/lazadaApi';
import tiktokApi from '../api/tiktokApi';

export const NO_AFF_LINK_MESSAGE =
    'Chưa tạo được link hoàn tiền (sàn đang quá tải). Vui lòng bấm lại sau ít giây.';

/**
 * Lấy link mua hàng ĐÃ gắn tracking: s.shopee.vn/an_redir (sub_id + affiliate_id),
 * deeplink/shortlink Lazada, hoặc showcase TikTok.
 *
 * KHÔNG BAO GIỜ rơi về link sản phẩm gốc. Link trần không mang subId/affId nên đơn
 * mua qua đó không được sàn ghi nhận — user mất hoàn tiền mà không hề biết. Thà ném
 * lỗi để màn hình báo "thử lại" còn hơn im lặng mở link hỏng.
 *
 * @param {{platform?: string, productLink?: string, productId?: string|number, meta?: object}} product
 * @param {string} source giá trị LinkSource để quy đơn về đúng màn hình
 * @returns {Promise<{url: string, followUpUrl?: string}>}
 * @throws {Error} khi sàn không trả về link affiliate
 */
export default async function resolveBuyLink(product, source) {
    const { platform, productLink, productId, meta = {} } = product || {};

    if (platform === 'lazada') {
        const { data } = await lazadaApi.getLinkAffByUrl(productLink, meta, source);
        const deepLink = data?.linkAff?.deepLink;
        const shortLink = data?.linkAff?.shortLink;
        if (!deepLink && !shortLink) throw new Error(NO_AFF_LINK_MESSAGE);
        // deepLink mở thẳng app Lazada; máy chưa cài app thì 2.5s sau chuyển shortLink
        return {
            url: deepLink || shortLink,
            followUpUrl: deepLink && shortLink ? shortLink : undefined,
        };
    }

    if (platform === 'tiktok') {
        const { data } = await tiktokApi.addToShowCase(productId, meta);
        const shopId = data?.showCase?.[0]?.tiktokshopId;
        if (!shopId) throw new Error(NO_AFF_LINK_MESSAGE);
        return { url: `https://tiktok.com/${shopId}` };
    }

    if (platform !== 'shopee') throw new Error(NO_AFF_LINK_MESSAGE);

    const { data } = await shopeeApi.getLinkAff(productLink, source);
    const link = data?.data?.batchCustomLink?.[0]?.shortLink;
    if (!link) throw new Error(NO_AFF_LINK_MESSAGE);
    return { url: link };
}
